import React, { useEffect, useState } from 'react'
import PerfilesAgendate from '../CatalogoElements/PerfilesAgendate';
import { useAuthServices } from '../../services/useFetch';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'

const CatalogoLanding = () => {

    const { requestPost } = useAuthServices();

    const [modalError, setModalError] = useState(false)

    const [categoria1, setCategoria1] = useState(true)
    const [categoria2, setCategoria2] = useState(true)
    const [categoria3, setCategoria3] = useState(true)

    const perfilesAgendateList = [
        {
            id: 1, nombre: 'Dra. Angelica Peña', profesion: 'Fisioterapeuta', detalleProfesion: 'Especialista en cuidado crítico',
            tipoNegocio: 'NEGOCIO_1', tipoGestion: 'GESTION_1', ubicacion: 'Bogotá D.C.', direccion: '138, Cra. 5a #7 #13891, Bogotá',
            imageProfile: 'https://appsmartechbucket.s3.us-east-1.amazonaws.com/WhatsApp+Image+2025-10-07+at+6.46.43+PM.jpeg'
        },
        {
            id: 2, nombre: 'Juan Perez', profesion: 'Estilista profesional', detalleProfesion: '',
            tipoNegocio: 'NEGOCIO_2', tipoGestion: 'GESTION_1', ubicacion: 'Yopal - Casanare', direccion: 'Cl. 13 # 29 36, Yopal, Casanare',
            imageProfile: 'https://appsmartechbucket.s3.us-east-1.amazonaws.com/WhatsApp+Image+2025-10-07+at+6.46.43+PM.jpeg'
        },
        {
            id: 3, nombre: 'Clínica Salud y Bienestar', profesion: '', detalleProfesion: '',
            tipoNegocio: 'NEGOCIO_1', tipoGestion: 'GESTION_2', ubicacion: 'Bogotá D.C.', direccion: 'Calle 134 #7b-41',
            imageProfile: 'https://appsmartechbucket.s3.us-east-1.amazonaws.com/WhatsApp+Image+2025-10-07+at+6.46.43+PM.jpeg'
        },
        {
            id: 4, nombre: 'Erwin Castiblanco', profesion: 'Barbero', detalleProfesion: '',
            tipoNegocio: 'NEGOCIO_2', tipoGestion: 'GESTION_2', ubicacion: 'Tauramena - Casanare', direccion: 'Cl. 13 # 29 36, Yopal, Casanare',
            imageProfile: 'https://appsmartechbucket.s3.us-east-1.amazonaws.com/WhatsApp+Image+2025-10-07+at+6.46.43+PM.jpeg'
        },
        {
            id: 5, nombre: 'Dr. Clara Garcia', profesion: 'Veterinaria', detalleProfesion: 'Especialista en Gatos',
            tipoNegocio: 'NEGOCIO_3', tipoGestion: 'GESTION_1', ubicacion: 'Bogotá D.C.', direccion: 'Clinica de Marly',
            imageProfile: 'https://appsmartechbucket.s3.us-east-1.amazonaws.com/WhatsApp+Image+2025-10-07+at+6.46.43+PM.jpeg'
        },
    ]

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        obtieneCatalogoService()
    }, [])

    const obtieneCatalogoService = async () => {
        const body = {
            "tipoNegocio": ""
        }
        const response = await requestPost(body, 9);
        if (!response.error) {
            const { estado } = response.data
            if (estado) {

            } else {
                setModalError(true)
            }
        } else {
            setModalError(true)
        }
    }

    const handleCloseError = () => {
        setModalError(false)
    };

    return (
        <>
            <div className="row m-0 background-landing">
                <div className="col-12 col-sm-12 col-md-6 col-lg-6 p-0" >
                    <div className='div-container-landing'>
                        <h1 className='size-landing-h2'>
                            <span className='p-bold'> Explora servicios disponibles y agenda tu cita fácilmente</span>
                        </h1>
                        <p className='p-element-target-landing-2 margin-15' >
                            AGENDATE te conecta con profesionales de distintos sectores.
                            Explora los servicios disponibles según su especialidad, filtra por tipo de negocio y encuentra horarios que se ajustan a tu rutina.
                        </p>
                    </div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 col-lg-6 p-0" >
                    <div className='div-container-landing div-contenido-complementario-catalogo'>
                        <p className='p-element-target-landing-2 margin-15' >
                            Una vitrina dinámica y confiable que reúne a los profesionales registrados en AGENDATE.
                            Aquí puedes descubrir, comparar y agendar servicios de manera rápida, segura y personalizada.
                        </p>
                        <p className='p-element-target-landing-2 margin-15' >
                            AGENDATE te conecta con expertos de múltiples sectores, desde salud y bienestar hasta servicios de belleza y veterinarias.
                            Cada perfil incluye información clara sobre el servicio ofrecido, ubicación, disponibilidad y reputación del profesional.
                        </p>
                    </div>
                </div>
            </div>
            <h1 className='size-landing-h2'>
                <span className='p-bold'>Selecciona uno o más servicios para explorar perfiles y disponibilidad</span>
            </h1>
            <p className='p-element-target-landing-2 margin-15' >
                Explora las categorías disponibles, encuentra el profesional ideal para ti y accede a su calendario en tiempo real:
            </p>
            <div className="row m-0">
                <div className="col-12 col-sm-12 col-md-4 col-lg-4" >
                    <div className='div-filtros-tags-catalogo-padre'>
                        <div className={categoria1 ? 'div-filtros-tags-catalogo-active' : 'div-filtros-tags-catalogo'} onClick={() => setCategoria1(!categoria1)}>
                            Servicios de Salud
                        </div>
                    </div>
                </div>
                <div className="col-12 col-sm-12 col-md-4 col-lg-4" >
                    <div className='div-filtros-tags-catalogo-padre'>
                        <div className={categoria2 ? 'div-filtros-tags-catalogo-active' : 'div-filtros-tags-catalogo'} onClick={() => setCategoria2(!categoria2)}>
                            Servicios de Belleza
                        </div>
                    </div>
                </div>
                <div className="col-12 col-sm-12 col-md-4 col-lg-4" >
                    <div className='div-filtros-tags-catalogo-padre'>
                        <div className={categoria3 ? 'div-filtros-tags-catalogo-active' : 'div-filtros-tags-catalogo'} onClick={() => setCategoria3(!categoria3)}>
                            Servicios Veterinarios
                        </div>
                    </div>
                </div>
            </div>
            <div className='div-container-landing'>
                <div className="row m-0">
                    {
                        perfilesAgendateList.map((perfil) => (
                            <div key={perfil.id} className="col-12 col-sm-12 col-md-6 col-lg-6 my-2" >
                                <PerfilesAgendate propsPerfil={perfil} />
                            </div>
                        ))
                    }
                </div>
            </div>
            <Modal isOpen={modalError} onHide={handleCloseError} className='modal-perfil-cliente'>
                <ModalHeader closeButton>
                    <h4>Error de comunicación <FontAwesomeIcon icon={faExclamationTriangle} className='icon-error' /> </h4>
                </ModalHeader>
                <ModalBody>
                    <p>Vaya, tenemos algunas dificultades de comunicación en este momento, por favor intenta mas tarde.</p>
                </ModalBody>
                <ModalFooter>
                    <Button variant="primary" onClick={handleCloseError}>
                        Aceptar
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    )
}

export default CatalogoLanding